<template>
  <div class="tableWithPerPageSelection">
    <a ref="lienDownload"></a>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="manageActions"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="someSelected"
            ></selecteur-action>
          </div>
        </div>
      </div>
      <div class="columns level-right">
      </div>
    </div>
    <v-client-table
        url=""
        v-model="clientsSelected"
        :columns="columns"
        :options="options"
        @filter="refreshFilteredData"
        ref="clientInSelectionTable">
      <template slot="code" slot-scope="props">
        <div class="is-pulled-left">
          {{props.row.code}}
        </div>
      </template>
      <template slot="adressePostale.adresse1" slot-scope="props">
        <span v-if="props.row.adressePostale">{{props.row.adressePostale.adresse1}}</span>
      </template>
      <template slot="adressePostale.codePostal" slot-scope="props">
        <span v-if="props.row.adressePostale">{{props.row.adressePostale.codePostal}}</span>
      </template>
      <template slot="adressePostale.ville" slot-scope="props">
        <span v-if="props.row.adressePostale">{{props.row.adressePostale.ville}}</span>
      </template>
      <template slot="selected" slot-scope="{ row, update }">
        <div class="has-text-centered">
          <b-checkbox v-model="row.selected"
                      @input="update">
          </b-checkbox>
        </div>
      </template>
      <template slot="nomCommercial" slot-scope="props">
        <router-link :to="{ name: 'c.bodac.clients/contacts-client', params: {id: props.row.id}}"
                     class="lien" :class="{'text-access-no-permission':
                                   !checkPermissions(permClient.lecture)}">
          {{props.row.nomCommercial}}
        </router-link>
      </template>
      <template slot="delete" slot-scope="{ row }">
        <div @click="$emit('removeSelection', [row])" class="is-cursor-pointer has-text-centered">
          <b-icon type="is-danger" icon="delete-forever"></b-icon>
        </div>
      </template>
      <template slot="color" slot-scope="{ row, update }">
        <div class="has-text-centered">
          <colorPicker
            v-model="row.color"
            @input="update">
          </colorPicker>
        </div>
      </template>
    </v-client-table>
    <b-modal v-model="popupColorChange">
      <div class="card pd-40px">
        <h1 class="title is-size-2 pdb-20px">{{$t('cartographie.popup.title')}}</h1>
        {{selectedColor}}
        <div class="card-content mgl-20px">
          <colorPicker
              v-model="selectedColor"
              :isIcon="false"
              :size="40">
          </colorPicker>
        </div>
        <footer class="mgt-20px">
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="popupColorChange = false">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="updateColor">
              {{ $t('cartographie.popup.appliquer') }}
            </a>
          </div>
        </b-field>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import {
  NO_PAGINATION,
  NO_PER_PAGE_VALUE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { COULEUR_PUCE_DEFAULT } from '@/configuration/general/carteConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { ACTION_DELETE_SELECTION, ACTION_APPLY_COLOR } from '@/configuration/cartographie/cartographie';
import messageErreur from '@/services/general/messageErreur';
import selecteurAction from '@/components/general/selecteurAction';
import colorPicker from '@/components/general/button/colorPicker';
import { TIERS } from '@/configuration/permissionsBodacConf';

const Permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    clients: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      COULEUR_PUCE_DEFAULT,
      popupColorChange: false,
      selectedColor: COULEUR_PUCE_DEFAULT,
      permClient: TIERS,
      filteredData: [],
    };
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse);
    },
  },
  components: {
    selecteurAction,
    colorPicker,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    clientsSelected: {
      get() {
        return this.clients;
      },
      set(value) {
        this.$emit('update:clients', value);
      },
    },
    columns() {
      const column = ['selected', 'code', 'nomCommercial', 'nomJuridique', 'adressePostale.adresse1', 'adressePostale.codePostal', 'adressePostale.ville', 'telephone', 'portable', 'email', 'compteComptable', 'color', 'delete'];
      return column;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          nomCommercial: this.$i18n.t('listeClients.table.name'),
          nomJuridique: this.$i18n.t('listeClients.table.legalName'),
          'adressePostale.adresse1': this.$i18n.t('listeClients.table.address'),
          'adressePostale.codePostal': this.$i18n.t('listeClients.table.zipCode'),
          'adressePostale.ville': this.$i18n.t('listeClients.table.city'),
          telephone: this.$i18n.t('listeClients.table.phone'),
          portable: this.$i18n.t('listeClients.table.cellPhone'),
          email: this.$i18n.t('listeClients.table.email'),
          compteComptable: this.$i18n.t('listeClients.table.accountingCode'),
          color: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: ['code', 'nomCommercial', 'nomJuridique', 'adressePostale.adresse1', 'adressePostale.codePostal', 'adressePostale.ville', 'telephone', 'portable', 'email', 'compteComptable'],
        filterByColumn: true,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        texts: TEXTS,
        sortable: [],
        editableColumns: ['selected', 'color'],
        columnsClasses: {
          selected: 'colonneSelected',
          portable: 'colonneTelephone',
          telephone: 'colonneTelephone',
          adresse: 'colonneAdresse',
        },
      };
    },
    allSelected() {
      this.refreshFilteredData();
      return this.filteredData.length > 0 && this.filteredData.every(c => c.selected);
    },
    someSelected() {
      return this.clients.some(c => c.selected);
    },
    iconSelectTotal() {
      if (this.allSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    actions() {
      return [
        {
          action: ACTION_DELETE_SELECTION,
          translation: 'cartographie.actions.removeSelection',
        },
        {
          action: ACTION_APPLY_COLOR,
          translation: 'cartographie.actions.applyColor',
        },
      ];
    },
  },
  methods: {
    refreshFilteredData() {
      this.filteredData = this.$refs?.clientInSelectionTable?.allFilteredData ?? [];
    },
    updateColor() {
      this.clients.filter(c => c.selected).forEach(c => {
        this.$set(c, 'color', this.selectedColor);
      });
      this.popupColorChange = false;
      this.selectedColor = COULEUR_PUCE_DEFAULT;
    },
    selectAll() {
      const select = !this.allSelected;
      this.clients.forEach(f => {
        if (this.filteredData.map(f => f.id).includes(f.id)) f.selected = select;
      });
      this.refreshFilteredData();
    },
    manageActions(action) {
      switch (action) {
        case ACTION_DELETE_SELECTION:
          this.$emit('removeSelection', this.clients.filter((el) => el.selected));
          break;
        case ACTION_APPLY_COLOR:
          this.popupColorChange = true;
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('listeFace.errors.noActionSelect'));
          break;
      }
    },
  },
};

</script>
